import { createMinorSuitCore } from '../internal/core-builders';

export const MINOR_SWORDS_CORE = createMinorSuitCore('Spade');
